import styled from 'styled-components';
import { theme } from '../../../styles/theme';
import { floatingComponentStyles } from '../../../styles/shareableStyles';

export const Container = styled.div`
  min-width: 230px;
  ${floatingComponentStyles};
`;

export const DateWrapper = styled.div`
  font-size: 12px;
  color: ${theme.colors.secondary800};
  padding: 7px 12px 6px;
  border-bottom: 1px solid ${theme.colors.border};
`;

export const Content = styled.div`
  padding: 12px;
  > div {
    margin-bottom: 4px;
    &:last-child {
      margin-bottom: 0;
    }
  }
`;
